import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Root } from './components/Root.js'
import { config } from './utils/config.js'

const container = document.getElementById('tidal-sandbox-root') as HTMLElement
const enableStrictMode = !config.disableStrictMode

if (container) {
  enableStrictMode
    ? createRoot(container).render(
        <StrictMode>
          <Root />
        </StrictMode>,
      )
    : createRoot(container).render(<Root />)
}
